module.exports = "../images/fishing-lodge-05.jpg?v=0ab3158";